import React,  { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Alert, Spinner, Button } from 'react-bootstrap';
import List from '../components/list';
import Picker from '../components/mosqueePicker';
import { Link } from "react-router-dom";
import { db } from '../services/firebase';
import { signout } from "../helpers/auth";

const data = [
  {
    value: "gmca",
    label: "Grande mosquée de Clermont-Auvergne",
    adress: "15 Rue du Dr Nivet, 63100 Clermont-Ferrand"
  }
];

function Admin({ user }) {
  const [mosquee, setMosquee] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    db.collection("admins").doc(user).get().then(doc => {
        setMosquee(doc.data().code);
        setLoading(false);
    });
  }, [])

  return (
    <div className="w-100 bg-light">
      <Navbar bg="dark" variant="dark" className="d-flex justify-content-between align-items-center flex-column flex-sm-row pt-3">
        <div className="d-flex flex-column text-white ml-1 ml-sm-4 mb-sm-0 mb-3  text-center text-sm-left">
          <h4>Calendrier des prières à {mosquee ? data.find((item) => item.value === mosquee).label : "..."}</h4>
        </div>
        <span className="text-white mr-2 mr-sm-5 d-flex flex-column flex-sm-row align-items-sm-center">
            Connecté ({user})
            <Button className="ml-2 my-2" variant="light" onClick={signout}>Déconnexion</Button>
        </span>
      </Navbar>
      <div className="p-3 p-sm-5 d-flex flex-column justify-content-around h-100">
        <Alert variant="danger">
          Consignes COVID-19
        </Alert>
        {loading ? <Spinner animation="border" variant="dark" /> : <List mosquee={mosquee} admin={true} />}
      </div>
    </div>
  );
}

export default Admin;